<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-07-26 20:36:40
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-03 14:02:52
 * @FilePath: \partner.chaoyongtuan.com\src\views\sampleOrder\list\components\takeDialog.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog title="确认收货" :visible.sync="dialogVisible" width="620px" :before-close="handleClose">
		<el-alert title="手动确认收货后，以下包裹的物流状态全部变更为“已到货”，且无法恢复，是否确认操作？" type="warning" show-icon :closable="false" />
		<el-table class="mt-16" :data="list" header-row-class-name="table-header-row" row-class-name="table-row">
			<el-table-column prop="shipping_sn" label="物流单号" min-width="120" />
			<el-table-column prop="shipping_company" label="物流公司" min-width="80" />
			<el-table-column prop="delivery_time" label="发货时间" min-width="160" />
			<el-table-column prop="delivery_status_desc" label="当前物流状态" align="right" min-width="120" />
		</el-table>
		<span slot="footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="submit">全部确认到货</el-button>
		</span>
	</el-dialog>
</template>

<script>
import throttle from 'lodash/throttle';
import { getDeliverListV2, confirmation } from '@/api/cooperationProgress';

export default {
	name: 'takeDialog',
	data() {
		return {
			dialogVisible: false,
			cooperate_id: '',
			sample_sn: '',
			list: [],
		};
	},
	methods: {
		show(cooperate_id, sample_sn) {
			this.sample_sn = sample_sn;
			this.cooperate_id = cooperate_id;
			this.getInfo();
			this.dialogVisible = true;
		},
		handleClose() {
			this.cooperate_id = '';
			this.sample_sn = '';
			this.list = [];
			this.dialogVisible = false;
		},
		async getInfo() {
			const { cooperate_id, sample_sn } = this;
			const { code, data } = await getDeliverListV2({ cooperate_id, sample_sn });
			if (code !== 0) return;
			if (!data.cooperate_id) this.list = [];
			let delivery_list = data.delivery_list;
			this.list = delivery_list.map(item => {
				return {
					...item,
					delivery_status_desc: data.delivery_status_desc,
					delivery_time: data.delivery_time,
				};
			});
		},
		submit: throttle(async function() {
			const { cooperate_id, sample_sn } = this;
			const { code } = await confirmation({ cooperate_id, sample_sn });
			if (code !== 0) return;
			this.$message.success('收货成功');
			this.handleClose();
			this.$emit('getList');
		}, 1000),
	},
};
</script>

<style lang="less" scoped></style>
